import React from "react";

import { CRSResource, Provider, Resource } from "src/api/connectApi/types";
import EquifaxIcon from "src/assets/EquifaxIcon.svg?react";
import ExperianIcon from "src/assets/ExperianIcon.svg?react";
import LexisNexisIcon from "src/assets/LexisNexisIcon.svg?react";
import TransunionIcon from "src/assets/TransunionIcon.svg?react";
import { ProviderIcon } from "src/connections/config/Icon";
import { NodeIcon, NodeIconSize } from "src/design-system/NodeIcon";
import { assertUnreachable } from "src/utils/typeUtils";

type Props = {
  provider: Provider | string;
  resource: Resource | string;
  size?: NodeIconSize;
};

export const ResourceIcon: React.FC<Props> = ({
  provider,
  resource,
  size = "md",
}) => {
  if (provider === "crs") {
    const crsResource = resource as CRSResource;
    switch (crsResource) {
      case "transunion_imv_basic":
      case "transunion_credit_report": {
        return <NodeIcon svg={TransunionIcon} size={size} />;
      }
      case "experian_business_profile_report":
      case "experian_business_search":
      case "experian_credit_report":
      case "experian_intelliscore_business_report": {
        return <NodeIcon svg={ExperianIcon} size={size} />;
      }
      case "lexisnexis_bridger_search": {
        return <NodeIcon svg={LexisNexisIcon} size={size} />;
      }
      case "crs_equifax_credit_report": {
        return <NodeIcon svg={EquifaxIcon} size={size} />;
      }
      default:
        assertUnreachable(crsResource);
        return <></>;
    }
  } else {
    return <ProviderIcon provider={provider} size={size} />;
  }
};
